exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#collaborate-comment-add[data-v-d518ba24]{position:relative;background-color:#fff;z-index:2;box-shadow:0 .75rem 1.5rem rgba(18,38,63,.03)}#collaborate-comment-add.static[data-v-d518ba24]{position:static}", ""]);

// exports
